import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GeneralAttachmentDto } from '../../models/attachment';
import { AttachmentService } from '../../services/attachment-service';
import { BaseComponent } from '../component-base';



@Component({
  selector: 'app-attachment-list-details',
  templateUrl: './attachment-list-details.component.html'
})
export class AttachmentListDetailsComponent extends BaseComponent {
  @Input() attachments: GeneralAttachmentDto[] = [];
  @Input() allowDelete: boolean = true;
  @Output() delete = new EventEmitter<number>();

  constructor(public attachmentService: AttachmentService) {
    super();
  }

  isImageExtension(extension: string): boolean {
    return ['.png', '.jpeg', '.jpg'].includes(extension.toLowerCase());
  }

  isExcelExtension(extension: string): boolean {
    return ['.xls', '.xlsx'].includes(extension.toLowerCase());
  }

  isWordExtension(extension: string): boolean {
    return ['.doc', '.docx'].includes(extension.toLowerCase());
  }

  isPowerPointExtension(extension: string): boolean {
    return ['ppt', 'pptx'].includes(extension.toLowerCase());
  }

  onDelete(id: number): void {
    this.delete.emit(id);
  }

  onDownload(attachmentId: string, fileName: string) {
    this.attachmentService.download(attachmentId).subscribe({
      next: (blob) => {
        if (blob) {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      },
      error: (err) => {
        this.toastrService.error(this.translate.instant('common.errorContent'), "");
      }
    });
  }

}
